import React, { useMemo, createElement } from 'react';
import { isGroupUrl, isFromCourseMiniApp, openCourseInMp } from '../../services/util';

interface IProps {
    children: React.ReactElement;
}

/** 可以处理在小程序中利用a标签打开课程的操作 */
export const PreA = (props: IProps) => {
    const { children } = props;

    return useMemo(() => {
        if (!children || children.type !== 'a') {
            return children;
        }
        const childProps = { ...children.props };
        const isStringHref = typeof children.props.href === 'string';
        if (isStringHref) {
            const groupId = isGroupUrl(children.props.href);
            if (isFromCourseMiniApp() && groupId) {
                childProps.href = 'javascript:;';
                childProps.onClick = (e: any) => {
                    children.props.onClick && children.props.onClick(e);
                    openCourseInMp({ groupId });
                };
                return createElement('a', childProps);
            }
        }
        return children;
    }, [children]);
};
